/* Judge.me Custom Carousel Logic */
function initJudgemeCarousel() {
  const track = document.querySelector('.jm-carousel__track');
  const widget = document.querySelector('.jdgm-carousel-review-list');
  const viewport = document.querySelector('.jm-carousel__viewport');
  
  if (!track || !widget || !viewport || widget.classList.contains('jm-custom-carousel-initialized')) return;
  widget.classList.add('jm-custom-carousel-initialized');
  
  // 1. Add Navigation Arrows
  const leftArrow = document.createElement('button');
  leftArrow.className = 'jm-carousel-custom-arrow left';
  leftArrow.setAttribute('aria-label', 'Previous reviews');
  leftArrow.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
  
  const rightArrow = document.createElement('button');
  rightArrow.className = 'jm-carousel-custom-arrow right';
  rightArrow.setAttribute('aria-label', 'Next reviews');
  rightArrow.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
  
  viewport.appendChild(leftArrow);
  viewport.appendChild(rightArrow);
  
  const getScrollAmount = () => {
    const item = track.querySelector('.jm-carousel-review-item');
    if (!item) return track.clientWidth * 0.8;
    // Scroll by 2 items usually, or 1 item on mobile
    const itemWidth = item.offsetWidth + parseFloat(getComputedStyle(track).gap || 24);
    return window.innerWidth > 749 ? itemWidth * 2 : itemWidth;
  };
  
  leftArrow.addEventListener('click', () => {
    track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
  });
  
  rightArrow.addEventListener('click', () => {
    track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
  });
  
  // 2. Add Mouse Drag (Swipe) functionality
  let isDown = false;
  let startX;
  let scrollLeft;
  let isDragging = false;
  
  track.addEventListener('mousedown', (e) => {
    isDown = true;
    isDragging = false;
    startX = e.pageX - track.offsetLeft;
    scrollLeft = track.scrollLeft;
  });
  
  track.addEventListener('mouseleave', () => {
    isDown = false;
    track.classList.remove('is-dragging');
  });
  
  track.addEventListener('mouseup', () => {
    isDown = false;
    track.classList.remove('is-dragging');
  });
  
  track.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - track.offsetLeft;
    const walk = x - startX;
    
    // Only count as dragging if mouse moved more than 5px
    if (Math.abs(walk) > 5) {
      isDragging = true;
      track.classList.add('is-dragging');
    }
    
    track.scrollLeft = scrollLeft - (walk * 1.5);
  });
  
  // Prevent click on items if a drag occurred
  track.addEventListener('click', (e) => {
    if (isDragging) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
}

// Observe dynamically loaded Judge.me widget
document.addEventListener('DOMContentLoaded', () => {
  initJudgemeCarousel();
  
  const observer = new MutationObserver((mutations) => {
    if (document.querySelector('.jm-carousel__track') && !document.querySelector('.jm-custom-carousel-initialized')) {
      initJudgemeCarousel();
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
});